// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EnergySavingVisualization_container__vj\\+zi {
  overflow: hidden;
  overflow-x: scroll;
  background-color: white;
  height: 68px;
}

.EnergySavingVisualization_pattern__WYPMO {
  height: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/components/EnergySaving/EnergySavingVisualization.module.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;AACJ;;AAEA;EACI,YAAA;AACJ","sourcesContent":[".container {\n  overflow: hidden;\n  overflow-x: scroll;\n  background-color: white;\n  height: 68px;\n}\n\n.pattern {\n  height: 3rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EnergySavingVisualization_container__vj+zi`,
	"pattern": `EnergySavingVisualization_pattern__WYPMO`
};
export default ___CSS_LOADER_EXPORT___;
